<template lang="pug">
.section
  .section-header
      h1 {{ $t("ui.operator_summary") }}
  .section-body
    .row
      .col-12
        .card.mb-0
          .card-header
            .row.w-100
              .form-group.col-md-3.col-3.mb-1
                b-input-group(size="sm")
                  b-form-select.col-5(v-model="searchType" size="sm" @change="initSearchData()")
                    option(value="business_id") {{ $t('ui.business_id') }}
                    option(value="operator_id") {{ $t('ui.operator_id') }}
                  DebounceInput(autofocus type="text" v-model="searchData" :placeholder="$t('message.search_by_' + searchType)" @enter="getOperatorSummary()" size="sm")

              .form-group.col-6.mb-1
                SubmitButton(
                  :loading="loading"
                  icon="fa fa-search"
                  :text="$t('ui.search')"
                  type="button"
                  @click="getOperatorSummary()"
                  variant="primary"
                  size="sm"
                )
          .card-body
            .row
              .col-12.mb-1(v-if="operatorProfile.length > 0")
                h2.section-title.mt-0 
                  div.d-inline-block
                    span.mb-1 {{ $t('ui.operator_id') }}&ensp;
                    span.badge-sm.badge-pill.badge-info.py-1.px-2.d-inline-block {{ operatorProfile[0].operator_id }}
                  div.d-inline-block.ml-3
                    span {{ $t('ui.business_id') }}&ensp;
                    span.badge-sm.badge-pill.badge-warning.py-1.px-3.d-inline-block {{ operatorProfile[0].business_id }}

              .col-12
                .clusterize-scroll.table-responsive
                  table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
                    thead.thead-light
                      tr
                        th.text-center(width="4%")
                          span #
                        th(width="15%")
                          span(:title="$t('ui.domain_name')") {{ $t('ui.domain_name') }}
                        th(width="10%")
                          span(:title="$t('ui.domain_type')") {{ $t('ui.domain_type') }}
                        th.text-center(width="10%")
                          span(:title="$t('ui.domain_group')") {{ $t("ui.domain_group") }}
                        th.text-center(width="6%")
                          span(:title="$t('ui.status')") {{ $t("ui.status") }}
                        th(width="12%")
                          span(:title="$t('ui.android_app_link')") {{ $t("ui.android_app_link") }}
                        th.text-right(width="10%")
                          span(:title="$t('ui.price')") {{ $t("ui.price") }}
                        th(width="13%")
                          span(:title="$t('ui.remark')") {{ $t("ui.remark") }}
                        th.text-right(width="10%")
                          span(:title="$t('ui.created_date')") {{ $t("ui.created_date") }}

                    tbody.clusterize-content
                      tr(v-if="operatorSummaryList.length == 0")
                        td(colspan="10").text-center
                          span {{ $t('message.no_data_available') }}
                      tr(v-for="(item, index) in operatorSummaryList")
                        td.text-center
                          span(:title="index + 1") {{ index + 1 }}
                        td
                          span(:title="item.domain_name") {{ item.domain_name }}
                        td
                          span(:title="item.domain_type") {{ item.domain_type }}
                        td.text-center
                          span(:title="item.domain_group") {{ item.domain_group }}
                        td.text-center
                          i(:class="{ 'fas fa-check text-success': item.status == 'ACTIVE', 'fas fa-times text-warning': item.status == 'DEACTIVATE'}")
                        td
                          template(v-if="item.domain_group == 'MEMBER'")
                            span(:title="item.android_sub") {{ item.android_sub }}
                            span.mr-1.float-right(v-if="item.android_sub == null || item.android_sub == ''")
                              a.fa.fa-edit.btn.btn-ssm.btn-primary(href="javascript:void(0)" @click="onEdit(item)" :title="$t('ui.edit')")
                            span.mr-1.float-right.ml-2(v-else)
                              a.fa.fa-trash.btn.btn-ssm.btn-danger(href="javascript:void(0)" @click="onDelete(item, 'android')" :title="$t('ui.delete')")
                          span(v-else) -
                        td.text-right
                          span(:title="$n(item.price, 'currency')") {{ item.price ? $n(item.price, 'currency') : "-" }}
                        td
                          span(:title="item.remark") {{ item.remark }}
                        td.text-right
                          span(:title="item.created_by") {{ item.created_by }}
                          br
                          span(:title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}

  adddomainapplink(ref="adddomainapplink" :item="editSelectedDomain" :appType="editSelectedAppType" @clicked="afterEditAppLink" @failed="handleFailed")

</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import adddomainapplink from "@/components/domain/addDomainAppLink.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    adddomainapplink
  },
  data: () => ({
    loading: false,
    operatorSummaryList: [],
    currentPage: 1,
    totalRow: 0,
    searchType: "business_id",
    searchData: null,
    operatorId: "",
    operatorProfile: [],
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    editSelectedDomain: null,
    editSelectedAppType: 'ANDROID'
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    accountType() {
      return this.$store.getters.accountType;
    },
    isAdmin() {
      return this.$store.getters.accountType === 5;
    },
    isAdminMaster() {
      return [3,5].includes(this.$store.getters.accountType);
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID
    }
  },
  mounted: function() {},
  methods: {
    onEdit(e) {
      this.editSelectedDomain = e;
      this.editSelectedAppType = 'ANDROID'
      this.$refs.adddomainapplink.$refs.addDomainAppLink.show();
    },
    afterEditAppLink: function() {
      this.getOperatorSummary();
      this.$helpers.showDialog(this.$t("ui.add_" + this.editSelectedAppType.toLowerCase() + "_app_link"), this.$t("message.success"), "success");
    },
    onDelete: function(item, apptype) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.delete_" + apptype + "_app_link_confirm", { name: item.domain_name }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmDomainAppLinkDelete(item, apptype);
          }
        });
    },
    confirmDomainAppLinkDelete: function(item, apptype) {
      let url = config.domainAppLinkRemoveUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        domain_id: item.domain_id,
        app_type: apptype.toUpperCase()
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                // item.status = status;
                this.getOperatorSummary();
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function() {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    },
    initSearchData() {
      this.searchData = null;
      this.operatorSummaryList = []
      this.operatorProfile = []
    },
    getOperatorSummary: function() {
      if(this.searchData == null || this.searchData.trim() == '') {
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.isRequired", { fname: this.$t("ui." + this.searchType) }), "error");
        return
      }
      let url = config.getOperatorSummaryUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken
      };

      if (this.searchType == 'business_id')
        json.business_id = this.searchData;

      if (this.searchType == 'operator_id'){
        json.operator_id = this.searchData;
      }

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;

              if (this.feedback.success == true) {
                if(response.data.ds.domain.length > 0)
                  this.operatorSummaryList = response.data.ds.domain;
                else
                  this.operatorSummaryList = []
                if(response.data.ds.profile.length > 0)
                  this.operatorProfile = response.data.ds.profile
                else
                  this.operatorProfile = []
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    }
  }
};
</script>